import { canv } from '@/canv/global.js'

export class shapeBraceLeft {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 18/20 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width * 18/20 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width, y);
        canv.ctx.arcTo(x + width * 19/20, y + height * 1/20, x + width * 19/20, y + height/2, width / 20);
        canv.ctx.lineTo(x + width * 19/20, y + height * 9/20);
        canv.ctx.lineTo(x + width * 18/20, y + height * 10/20);
        canv.ctx.lineTo(x + width * 19/20, y + height * 11/20);
        canv.ctx.arcTo(x + width * 19/20, y + height * 19/20, x + width, y + height, width / 20);
        canv.ctx.lineTo(x + width, y + height);
    }

    getAvatar(color) {
        return `
        <svg width="37" height="88" viewBox="0 0 37 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36.7273 84H33.0909C29.2331 84 25.5335 82.4676 22.8058 79.7396C20.0778 77.012 18.5455 73.3124 18.5455 69.4545V58.5455C18.5455 55.6524 17.396 52.8775 15.3502 50.8316C13.3044 48.7858 10.5296 47.6364 7.63636 47.6364C6.67193 47.6364 5.74702 47.2531 5.06505 46.5713C4.38313 45.8895 4 44.9644 4 44C4 43.0356 4.38313 42.1105 5.06505 41.4287C5.74702 40.7469 6.67193 40.3636 7.63636 40.3636C10.5296 40.3636 13.3044 39.2142 15.3502 37.1684C17.396 35.1226 18.5455 32.3478 18.5455 29.4545V18.5455C18.5455 14.6877 20.0778 10.9881 22.8058 8.26025C25.5335 5.53247 29.2331 4 33.0909 4H36.7273"
        stroke="` + color + `" stroke-width="7"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 12 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2273 26H10.0909C8.88534 26 7.7292 25.5211 6.87682 24.6686C6.02432 23.8162 5.54545 22.6601 5.54545 21.4545V18.0455C5.54545 17.1414 5.18625 16.2742 4.54693 15.6349C3.90762 14.9956 3.04051 14.6364 2.13636 14.6364C1.83498 14.6364 1.54594 14.5166 1.33283 14.3035C1.11973 14.0905 1 13.8014 1 13.5C1 13.1986 1.11973 12.9095 1.33283 12.6965C1.54594 12.4834 1.83498 12.3636 2.13636 12.3636C3.04051 12.3636 3.90762 12.0044 4.54693 11.3651C5.18625 10.7258 5.54545 9.85869 5.54545 8.95455V5.54545C5.54545 4.33992 6.02432 3.18377 6.87682 2.33133C7.7292 1.4789 8.88534 1 10.0909 1H11.2273" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
